export type SearchParamsBase = Record<string, string | number | Array<string | number | null | undefined> | null | undefined>;

export type BuildSearchParamStringConfig = {
	/**
	 * Prepend `?` to the start of the resulting string.
	 * @default false
	 */
	prependQuestionMark?: boolean;
};

export function buildSearchParamString<TParams extends SearchParamsBase>(params: TParams | null | undefined, config: BuildSearchParamStringConfig = {}) {
	if (!params) return undefined;

	const builder = new URLSearchParams();
	for (const [key, value] of Object.entries(params)) {
		if (value === null || value === undefined) continue;
		if (Array.isArray(value)) {
			for (const valueItem of value) {
				if (valueItem === null || valueItem === undefined) continue;
				builder.append(key, valueItem.toString());
			}
		} else {
			builder.set(key, value.toString());
		}
	}

	let result = builder.toString();
	if (config.prependQuestionMark && result.length > 0 && !result.startsWith('?')) {
		result = `?${result}`;
	}

	return result;
}
